<template>
  <!-- -->
  <div class="home-menu">
    <el-scrollbar class="menu-scrollbar">
      <!-- 精简模式 -->
      <view v-if="isCollapse" class="menu-list">
        <!--        <el-menu :default-active="secondMenu" background-color="#000" text-color="#FFF" :default-openeds="selectedMenuList" :collapse="true" unique-opened active-text-color="#409eff" @select="clickMenuList" :collapse-transition="false">-->
        <el-menu :default-active="secondMenu" background-color="#FFF" text-color="#000"
                 :default-openeds="selectedMenuList" :collapse="true" unique-opened active-text-color="#409eff"
                 @select="selectUrl" :collapse-transition="false">
          <div v-for="(m,i) in menuList" :key="i">
            <el-sub-menu :index="m.moduleComponentUri" v-if="m.children && m.children.length > 0">
              <template #title>
                <div class="sub-menu-name">
                  <div class="module-icon">
                    <yq-icon :name="m.moduleIcon"/>
                  </div>
                  <div class="module-name">{{ m.moduleName }}</div>
                </div>
              </template>
              <el-menu-item :index="c.moduleComponentUri" v-for="(c, ci) in m.children" :key="`${i}_${ci}`">
                {{ c.moduleName }}
              </el-menu-item>
            </el-sub-menu>
            <el-menu-item v-else :index="m.moduleComponentUri" class="first-level" @click.stop="panelClick(m)">
              <yq-icon :name="m.moduleIcon"/>
              <span class="module-name">{{ m.moduleName }}</span>
            </el-menu-item>
          </div>
        </el-menu>
      </view>
      <!-- 树形模式 -->
      <view v-else class="menu-tree">
        <el-collapse v-model="firstMenu" accordion>
          <el-collapse-item v-for="(item, index) in menuList" :key="index" :name="item.moduleComponentUri">
            <template #title>
              <div @click="panelClick(item)" style="width: 100%;text-align: left">
                <yq-icon class="menu-icon" :name="item.moduleIcon"/>
                <span class="module-name">{{ item.moduleName }}</span>
              </div>
            </template>
            <div v-if="item.children">
              <div v-for="(child) in item.children" class="menu-level2"
                   :class="secondMenu === child.moduleComponentUri? 'on': ''" :key="child.id"
                   @click.stop="clickMenuList(child)">{{ child.moduleName }}
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </view>

    </el-scrollbar>
  </div>
</template>

<script>
import YqIcon from "@/components/YqIcon.vue";
import {watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import util from "@/util/util";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  props: {
    isCollapse: {default: false},//是否收起
    menuList: {default: () => []},//菜单列表
    selectedMenu: {default: () => []}, // 被选中的菜单
  },
  name: "",
  components: {
    YqIcon
  },
  data() {
    return {
      selectedMenuList: [""],
      firstMenu: "", // 第一层的菜单
      secondMenu: "", // 第二层的菜单
      userInfo: {},
    };
  },
  created() {
    util.getUserInfo().then(user => this.userInfo = user);
    this.menuSelectedChange();
    watch(() => this.selectedMenu, () => {
      this.menuSelectedChange();
    })
  },
  methods: {
    menuSelectedChange() {
      if (!this.selectedMenu || this.selectedMenu.length === 0) {
        return;
      }
      if (this.selectedMenu.length > 0) {
        this.firstMenu = this.selectedMenu[0];
      }
      if (this.selectedMenu.length > 1) {
        this.secondMenu = this.selectedMenu[1];
      }
    },
    // 页签超限被阻止时，将菜单高亮重置回当前页面对应的菜单
    resetSelect() {
      const first = this.firstMenu;
      const second = this.secondMenu;
      // 先清空再恢复，强制触发 el-menu 的 default-active 更新，回退高亮
      this.firstMenu = "";
      this.secondMenu = "";
      this.$nextTick(() => {
        this.firstMenu = first;
        this.secondMenu = second;
      });
    },
    findMenu(url, list) {
      for (let i = 0; i < list.length; i++) {
        if (url === list[i].moduleComponentUri) {
          return list[i];
        }
        if (list[i].children && list[i].children.length > 0) {
          let data = this.findMenu(url, list[i].children);
          if (data) {
            return data;
          }
        }
      }
      return null;
    },
    selectUrl(url) { // 选中的数据是某个url
      let data = this.findMenu(url, this.menuList);
      if (data) {
        this.clickMenuList(data);
      }
    },
    clickMenuList(data) {
      if (data.moduleType === 2) {
        this.openOuterLink(data); // 打开外部链接
        return;
      } else if (data.moduleType === 3) { // 打开内部链接
        this.openInnerLink(data);
        return
      }
      let url = data.moduleComponentUri;
      // 根据这个url找到组件，向上级添加
      this.$emit("addTab", url);
    },
    routerPush(url) {
      if (url instanceof String) {
        if (this.route.path !== url) {
          this.router.push(url);
        }
      } else {
        this.router.push(url);
      }
    },
    openInnerLink(data) {
      window.open(data.moduleComponentUri + "?token=" + this.userInfo.token, "_blank", "noopener=yes,noreferrer=yes")
    },
    panelClick(data) {
      if (data.moduleType === 2) {
        this.openOuterLink(data); // 打开外部链接
      } else if (data.moduleType === 3) { // 打开内部链接
        this.openInnerLink(data);
      }
    },
    openOuterLink(data) {
      console.log("外部链接");
      window.open(data.moduleComponentUri, "_blank", "noopener=yes,noreferrer=yes")
    }
  }
};
</script>

<style lang="scss" scoped>
.home-menu {
  height: 100%;
  width: 100%;
  padding-top: 10px;
  overflow: hidden;
  box-sizing: border-box;
}

// 树形模式
.menu-tree {
  user-select: none;
  :deep(.el-collapse){
    border: none;
  }
  :deep(.el-collapse-item) {
    color: #334155;

    .el-collapse-item__content {
      padding: 0;
    }

    .el-collapse-item__header {
      border-bottom: none;
      cursor: pointer;
      background: transparent;
      color: #64748b;
      padding: 12px 16px !important;
      transition: all 0.3s ease;
      border-radius: 8px;
      margin: 0 8px;

      &:hover {
        background: #f1f5f9;
        color: #1e293b;
      }
    }

    .el-collapse-item__wrap {
      border-bottom: none;
      background: transparent;
      color: #334155;

      .el-collapse-item__content {
        color: #334155;
        padding: 4px 0;

        .menu-level2 {
          &:hover {
            background: #eff6ff;
            color: var(--el-color-primary);
          }

          &.on {
            //background: linear-gradient(135deg, #54a8ff 0%, #409eff 100%);
            color: #409eff;
            //box-shadow: 0 2px 6px rgba(64, 158, 255, 0.2);
          }
        }
      }
    }
  }

  .menu-icon {
    padding-left: 8px;
    font-size: 18px;
    padding-right: 10px;
    color: var(--el-color-primary);
  }

  .module-name {
    font-size: 14px;
    font-weight: 500;
  }

  .menu-level2 {
    padding-left: 48px;
    line-height: 40px;
    margin: 2px 8px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 13px;
    color: #64748b;

    &.on {
      color: var(--el-color-primary);
    }
  }
}

// 精简模式
.menu-list {
  :deep(.el-menu) {
    border-right: none;
    background: transparent;

    .el-sub-menu {
      .el-sub-menu__title {
        padding: 12px 0 !important;
        display: block;
        border-radius: 8px;
        margin: 4px 8px;
        transition: all 0.2s ease;

        &:hover {
          background: rgba(64, 158, 255, 0.1);
        }
      }

      .el-sub-menu__icon-arrow {
        display: none;
      }

      &.is-active {
        .el-sub-menu__title {
          background: rgba(64, 158, 255, 0.2);
        }
      }
    }

    .el-menu-item {
      padding: 12px 0 !important;
      border-radius: 8px;
      margin: 4px 8px;
      transition: all 0.2s ease;

      &:hover {
        background: #f1f5f9;
      }

      &.is-active {
        background: linear-gradient(135deg, #54a8ff 0%, #409eff 100%);
        color: #ffffff;
        box-shadow: 0 2px 6px rgba(64, 158, 255, 0.2);
      }
    }
  }

  .sub-menu-name {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;

    .module-icon {
      text-align: center;
      line-height: 24px;
      font-size: 20px;
      color: var(--el-color-primary);
    }

    .module-name {
      text-align: center;
      font-size: 11px;
      line-height: 18px;
      color: #64748b;
      margin-top: 4px;
    }
  }

  .first-level {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 24px;
    font-size: 11px;
    color: #64748b;

    .module-name {
      margin-top: 4px;
    }
  }
}

.menu-scrollbar {
  width: 100%;
  height: 100%;
}

:deep(.el-scrollbar__wrap) {
  overflow-x: hidden !important;
  overflow-y: auto;
  width: 100%;
}

:deep(.el-scrollbar__view) {
  padding-bottom: 10px;
  width: 100%;
  overflow-x: hidden;
}

:deep(.el-scrollbar__bar.is-vertical) {
  width: 6px;
  opacity: 0.6;
}

:deep(.el-scrollbar__bar.is-horizontal) {
  display: none !important;
}
</style>